import { ApprovalQueue } from '../components/approval/ApprovalQueue';

export function ReviewPage() {
  return <ApprovalQueue />;
}
